import Components from "slotworks/components/components";
import AbstractMediator from "slotworks/mediators/abstract-mediator";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Contract from "slotworks/utils/contract";
import HarleyComponents from "components/components";
import FreespinsWheelRecord from "integration/records/freespins-wheel-record";

export default class FreespinsMediator extends AbstractMediator {

    public start(): Contract<any> {
        this.update();

        return super.start();
    }

    private update() {
        const game = GameState.getCurrentGame();
        const record = game.getCurrentRecord();

        if(record instanceof FreespinsWheelRecord) {
            HarleyComponents.freespinsMeter.setTotalFreespins(record.spinsWon);
            HarleyComponents.freespinsMeter.setRemainingFreespins(Math.max(0, record.spinsWon - 1));
        } else if (record instanceof FreespinRecord) {
            HarleyComponents.freespinsMeter.setTotalFreespins(record.totalFreespins);
            HarleyComponents.freespinsMeter.setRemainingFreespins(Math.max(0, record.remainingFreespins - 1));
        } else if ((record as SpinRecord).freespinsWon) {
            HarleyComponents.freespinsMeter.setTotalFreespins((record as SpinRecord).freespinsWon);
            HarleyComponents.freespinsMeter.setRemainingFreespins(Math.max(0, game.getTotalFreespinsWon() - 1));
        } else {
            let currentRecordIndex = game.getCurrentRecordIndex();
            while (currentRecordIndex > 1) {
                currentRecordIndex--;

                const previousRecord = game.getRecordAtIndex(currentRecordIndex);
                if (previousRecord instanceof FreespinRecord) {
                    HarleyComponents.freespinsMeter.setTotalFreespins(previousRecord.totalFreespins);
                    HarleyComponents.freespinsMeter.setRemainingFreespins(Math.max(0, previousRecord.remainingFreespins - 1));
                    break;
                }
            }
        }

        Components.betBar.setEnabled(false);
    }
}
